// Offline mutation queue — persists pending operations in localStorage
// Flushes to Supabase when online

const QUEUE_KEY = 'kuadra2-mutation-queue';

let queue = [];

export function loadQueue() {
  try {
    queue = JSON.parse(localStorage.getItem(QUEUE_KEY) || '[]');
  } catch {
    queue = [];
  }
  return queue;
}

function saveQueue() {
  localStorage.setItem(QUEUE_KEY, JSON.stringify(queue));
}

export function enqueue(mutation) {
  queue.push({
    ...mutation,
    id: crypto.randomUUID(),
    timestamp: Date.now(),
  });
  saveQueue();
}

export function dequeue(id) {
  queue = queue.filter((m) => m.id !== id);
  saveQueue();
}

export function getQueue() {
  return [...queue];
}

export function clearQueue() {
  queue = [];
  saveQueue();
}

export function getQueueSize() {
  return queue.length;
}
